import React from 'react'
import moment from 'moment-timezone';
import { IntlProvider } from 'react-intl';
import { connect } from "react-redux";

import BookingRouter from '../Routes';
import LoadingScreen from '../components/Layout/LoadingScreen';

import CustomerIdentifier from '../utils/CustomerIdentifier';
import LocaleRetriever from '../utils/LocaleRetriever';
import request from '../utils/request';

import '../components/Layout/LoadingScreen/LoadingScreen.scss';
import { setSessionId, setTimestamp, getCustomerConfig, setCurrencyDatabase, getSessionId, getTimestamp, getSystemSettings, setSpotlioSessionId, getSpotlioSessionId, getFormData } from '../utils/SettingsRetriever';
import SalesIDRetriever from '../utils/SalesIDRetriever';
import { initGA } from "../utils/ga";

import { getItinerary as globalGetItinerary } from '../services/cart';
import { setForm } from "../services/form";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            customerState: false,
            settings: null,
            customerCalled: false,
            locale: null,
            error: null,
            autoModal: {}
        }
        this.adminMail = null;

        window.onerror = (message,file,line,column,errorObject) => {
            column = column || (window.event && window.event.errorCharacter);
            let stack = errorObject ? errorObject.stack : null;

            //trying to get stack from IE
            if (!stack) {
                //eslint-disable-next-line
                let stack = [];
                //eslint-disable-next-line
                let f = arguments.callee.caller;
                while (f) {
                    stack.push(f.name);
                    f = f.caller;
                }
                errorObject['stack'] = stack;
            }

            const data = {
                message:message,
                file:file,
                line:line,
                column:column,
                errorStack:stack,
            };

            //here I make a call to the server to log the error
            process.env.NODE_ENV === 'production' && this.handleReportError({data: data, location: window.location.href, timestamp: new Date()});
        }
    }

    componentDidMount() {
        Promise.all([
            this.CheckForLatestVersion(),
            CustomerIdentifier(),
        ]).then((resArr) => {
            const configs = resArr[1];
            if (configs[1] && configs[1].app && configs[1].app.adminMail) {
                this.adminMail = configs[1].app.adminMail;
            }
            if (getFormData() && getFormData().activities && getFormData().lodging){
                setForm(getFormData())
            } else {
                let form = {
                    "lodging": {
                        "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                        "nights": 2,
                        "adults": 1,
                        "children": 0
                    },
                    "activities": {
                        "startDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                        "rangeOfDays": 0
                    },
                    "liftTickets": {
                        "category": 117,
                        "days": 2,
                        "month": 9,
                        "year": 2020
                    },
                    "flights": {
                        "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                        "departureDate": moment.utc().add(4, 'days').format("YYYY-MM-DD"),
                        "departureAirport": {
                            "short": "BCN",
                            "name": "BCN Barcelona Arpt"
                        },
                        "arrivalAirport": "DFW",
                        "adults": 1,
                        "children": 0
                    },
                    "carRentals": {
                        "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                        "departureDate": moment.utc().add(4, 'days').format("YYYY-MM-DD"),
                        "location": {
                            "short": "HDN",
                            "name": "HDN Hayden Arpt"
                        },
                        "pickUpHour": "10:00 AM",
                        "dropOffHour": "10:00 AM"
                    }
                }
                if (configs[1] && configs[1].app && configs[1].app.forms){
                    if (configs[1].app.forms.lodging){
                        form.lodging = configs[1].app.forms.lodging;
                        if (configs[1].app.forms.lodging.mode && configs[1].app.forms.lodging.mode === "manual"){
                            form.lodging.arrivalDate = moment.utc().add(configs[1].app.forms.lodging.arrivalDate, 'days').format("YYYY-MM-DD");
                        }
                    }
                    if (configs[1].app.forms.activities) {
                        form.activities = configs[1].app.forms.activities;
                        if (configs[1].app.forms.activities.mode && configs[1].app.forms.activities.mode === "manual"){
                            form.activities.startDate = moment.utc().add(configs[1].app.forms.activities.startDate, 'days').format("YYYY-MM-DD");
                        }
                    }
                    if (configs[1].app.forms.flights) {
                        form.flights = configs[1].app.forms.flights;
                        if (configs[1].app.forms.flights.mode && configs[1].app.forms.flights.mode === "manual"){
                            form.flights.arrivalDate = moment.utc().add(configs[1].app.forms.flights.arrivalDate, 'days').format("YYYY-MM-DD");
                            form.flights.departureDate = moment.utc().add(configs[1].app.forms.flights.departureDate, 'days').format("YYYY-MM-DD");
                        }
                    }

                    if (configs[1].app.forms.carRentals){
                        form.carRentals = configs[1].app.forms.carRentals;
                        if (configs[1].app.forms.carRentals.mode && configs[1].app.forms.carRentals.mode === "manual"){
                            form.carRentals.arrivalDate = moment.utc().add(configs[1].app.forms.carRentals.arrivalDate, 'days').format("YYYY-MM-DD");
                            form.carRentals.departureDate = moment.utc().add(configs[1].app.forms.carRentals.departureDate, 'days').format("YYYY-MM-DD");
                        }
                    }
                }

                setForm(form)

            }
                // if there's no saved form and there's no default config...
            this.getLocale().then((locale) => {
                configs.push(locale);
                this.handleLoading(configs);
            });
        }).catch(err => this.setState({...this.state, error: err})); //catch of checkforlatestversion
    }

    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'production') {
            // this.handleReportError(error, errorInfo);
            this.setState({error: 'An unexpected error occurred.'});
        } else {
            console.error(error);
        }
    }

    CheckForLatestVersion() {
        return new Promise((resolve, reject) => {
            request({
                url: '/meta.json?t=' + new Date().getTime(),
                method: 'GET'
            })
            .then( (result) => {
                if(result.status !== 200){
                    reject('error retrieving version (0)');
                }

                if(global.appVersion !== result.data.version){
                    window.location.reload(true);
                }else{
                    resolve(true);
                }
            })
            .catch( () => reject('error retrieving version (1)'));
        });
    }

    generateSessionId(settings) {
        return new Promise((resolve, reject) => {
            request({
                url: settings.api + '/inntopia/session?salesid=' + SalesIDRetriever(),
                method: 'GET'
            })
            .then( (result) => {
                if(result.status !== 200){
                    reject('error setting your session (0)');
                }
                setTimestamp(new Date().getTime())
                setSessionId(result.data.SessionId);
            })
            .catch( () => reject('error setting your session (1)'));

            resolve(true);
        });
    }

    generateSpotlioSession(){
        return new Promise((resolve, reject) => {
            request({
                url: 'https://connect-dev.spotlio.com/session',
                method: 'POST'
            })
            .then( (result) => {
                setSpotlioSessionId(result.data.id);
                resolve(true);
            })
            .catch( () => reject('error setting your session (1)'));
        });
    }

    generateCurrencyDatabase(settings) {
        return new Promise((resolve, reject) => {
            if(settings){
                if(settings.app && settings.app.currency){
                    const CurrencySettings = settings.app.currency;
                    request({
                        url: 'https://7loc0h7tkk.execute-api.us-east-1.amazonaws.com/default/CurrencyExchange?base=' + CurrencySettings.list[CurrencySettings.default].base,
                        method: 'GET'
                    }).then(response => {
                        setCurrencyDatabase(response.data);
                        resolve();
                    }).catch(err => {
                        reject('could not get the currency database (13)');
                    });
                }
            }
        })
    }

    getLocale() {
        return new Promise((resolve, reject) => {
            import('../LocaleEngine/addLocales').then(locales => {
                resolve(locales.default);
            });
        })
    }

    handleLoading (configs) {
        let state = this.state;
        state = {
            ...state,
            customerState: configs[0],
            settings: configs[1],
            locale: configs[2],
            loading: false
        }
        if (process.env.NODE_ENV === 'development' && window.location.hash === '#crash') {
            state.error = 'forced error';
        }
        
        if (state.settings) {
            if (state.settings.maintenance && state.settings.maintenance.enabled !== false) {
                if (state.settings.maintenance.timezone){
                    let currentTime = moment().tz(state.settings.maintenance.timezone).format("YYYY-MM-DD HH:mm:ss Z")
                    if (currentTime > state.settings.maintenance.startTime && currentTime < state.settings.maintenance.endTime){
                        state.maintenance = true;
                    }
                } else {
                    if (state.settings.maintenance.startTime && state.settings.maintenance.endTime) {
                        const startTime = moment(state.settings.maintenance.startTime, 'YYYY-MM-DD HH:mm:ss Z').utc();
                        const endTime = moment(state.settings.maintenance.endTime, 'YYYY-MM-DD HH:mm:ss Z').utc();
                        const now = moment().utc();
                        if (now.unix() > startTime.unix() && now.unix() < endTime.unix()) {
                            state.maintenance = true;
                        }
                    }
                }
            }

            if (state.settings.operation_hours && state.settings.operation_hours.enabled){
                let currentTime = moment().tz(state.settings.operation_hours.timezone).format("HH:mm")
                if (currentTime < state.settings.operation_hours.startTime || currentTime > state.settings.operation_hours.endTime){
                    state.unoperational = true;
                }
            }
        }

        if (!getSessionId()) {
            this.generateSessionId(state.settings).then();
        } else {
            let sessionDuration = parseInt(getSystemSettings().sessionDuration) || 21600;
            if ( moment(getTimestamp()).add(sessionDuration, 'seconds') < moment() ){
                localStorage.clear();
                window.location.reload();
            }
        }

        if (!getSpotlioSessionId() && getSystemSettings().spotlioSession){
            this.generateSpotlioSession().then( () => {
                this.handleFinishLoading(state);
            })
        } else {
            this.handleFinishLoading(state);
        }
    }
    
    handleFinishLoading(state) {
        globalGetItinerary({ bundle: 1}).then(()=>{});
        if (state.settings.app.currency.list && state.settings.app.currency.list.length > 1) {
            this.generateCurrencyDatabase(state.settings).then(() => this.setState(state));
        } else {
            this.setState(state);
        }
    }

    handleReportError(stackTrace) {
        request({
            url: 'https://connect.spotlio.com/issues/report',
            method: 'POST',
            data: stackTrace
        });
    }

    render() {
        //if (this.state.loading || this.state.error || !system.hasOwnProperty('categories')) {
        if (this.state.loading || this.state.error || this.state.maintenance || this.state.unoperational) {
            if (this.state.error) {
                return (
                    <div className="LoadingScreen">
                        <h1 style={{transform: 'rotate(90deg)'}}>:-(</h1>
                        <p>Our systems returned the following error:</p>
                        <pre>{this.state.error}</pre>
                        <p>Please contact {this.adminMail ? <a href={`mailto:${this.adminMail}`}>{this.adminMail}</a> : 'the website administrator'} for help.</p>
                        {/* <img style={{width: '400px', height: 'auto'}} src="https://images.pexels.com/photos/127027/pexels-photo-127027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt="Sad cat is sad because of this" /> */}
                    </div>
                )
            }
            if (this.state.maintenance) {
                return (
                    <div className="MaintenanceMode">
                        <h1>{this.state.settings.maintenance.title}</h1>
                        <p dangerouslySetInnerHTML={{__html: this.state.settings.maintenance.message}} />
                    </div>
                )
            }
            if (this.state.unoperational) {
                return (
                    <div className="MaintenanceMode">
                        <h1>{this.state.settings.operation_hours.title}</h1>
                        <p dangerouslySetInnerHTML={{__html: this.state.settings.operation_hours.message}} />
                    </div>
                )
            }
            return <LoadingScreen />
        } else {
            const config = getCustomerConfig();
            const retrievedLocale = LocaleRetriever();
            const appLocale = this.state.locale[retrievedLocale].locale;
            const appMessages = this.state.locale[retrievedLocale].messages;

            initGA(this.state.settings);

            return (
                <IntlProvider locale={appLocale} messages={appMessages}>
                    <React.Fragment>
                        <BookingRouter system={this.state.settings} config={config} customerState={this.state.customerState}/>
                    </React.Fragment>
                </IntlProvider>
            );
        }
    }
}

function mapStateToProps(state) {
    return { form: state.form.form }
}

export default connect(mapStateToProps)(App)
